import SelectDebitAccount from './SelectDebitAccount.vue'

export default SelectDebitAccount
